import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity'
import type { CategoryEntity } from '@/features/category/domain/entities/CategoryEntity'
import type { VenderEntity } from '@/features/vender/domain/entities/VenderEntity'
import type { ItemOrderSupportType } from '../enums/ItemOrderSupportType'
import type { ItemApprovalStatus } from '@/backend/market'

export class ItemFilterEntity {
  branch?: BranchMiniEntity
  category?: CategoryEntity
  vender?: VenderEntity
  isAvailable?: boolean
  disabled?: boolean
  hasSelection?: boolean
  hasDiscount?: boolean
  searchWord?: string
  page?: number
  limit?: number
  sortField?: string
  sortDescending?: boolean
  date?: string[]
  orderSupportTypes?: Array<ItemOrderSupportType>
  hasNoImage?: boolean
  itemIds?: number[]
  approvalStatus?: ItemApprovalStatus
}
